<template>
  <div id="afterForm">
    <div v-if="result" class="reslut">
      <i class="far fa-check-circle fa-lg" style="margin-right:10px"></i>售后申请提交成功，我们会尽快处理！
    </div>
    <div v-else>
      <div class="box">
        <el-row style="margin-bottom:20px">
          <el-col :span="12">
            <div class="lv3Text">申请售后</div>
          </el-col>
        </el-row>
        <div>
          <el-table :data="[data]" style="width: 100%" border>
            <el-table-column label="商品信息">
              <template slot-scope="scope">
                <el-row>
                  <el-col :span="2">
                    <el-image class="cover2" :src="serve +data.images" fit="cover"></el-image>
                  </el-col>
                  <el-col :span="22">
                    <div class="lv2Text">{{scope.row.title}}</div>
                    <div class="lv3Text">货号：{{scope.row.item_no}}</div>
                  </el-col>
                </el-row>
              </template>
            </el-table-column>
            <!-- <el-table-column label="单价" width="120">
            <template slot-scope="scope">
              <div class="lv0Text">&yen;{{scope.row.selling_price}}</div>
            </template>
            </el-table-column>-->
            <el-table-column prop="number" label="数量" width="120"></el-table-column>
            <!-- <el-table-column label="合计" width="180">
            <template slot-scope="scope">
              <div class="lv1Text">&yen;{{scope.row.selling_price*scope.row.number}}</div>
            </template>
            </el-table-column>-->
          </el-table>
        </div>
        <div class="lv3Text" style="margin:20px 0">填写信息</div>
        <div class="form">
          <el-form label-position="right" label-width="100px" style="width:80%;margin:0 auto;">
            <el-form-item label="数量：">
              <el-input-number
                size="small"
                v-model="form.number"
                :max="_.toInteger(data.number)"
                :min="1"
              ></el-input-number>
            </el-form-item>
            <el-form-item label="售后类型：">
              <el-select v-model="form.type" placeholder="请选择">
                <el-option v-for="item in options" :key="item" :label="item" :value="item"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="原因：">
              <el-input
                type="textarea"
                :rows="5"
                placeholder="请填写原因，至少10个字或以上"
                v-model="form.cause"
                style="width:500px;"
              ></el-input>
            </el-form-item>
            <el-form-item label="上传图片：">
              <el-row :gutter="5">
                <el-col :span="4">
                  <div v-if="images[1]">
                    <img :src="images[1]" class="cover" />
                  </div>
                </el-col>
                <el-col :span="4">
                  <div v-if="images[2]">
                    <img :src="images[2]" class="cover" />
                  </div>
                </el-col>
                <el-col :span="4">
                  <div v-if="images[3]">
                    <img :src="images[3]" class="cover" />
                  </div>
                </el-col>
                <el-col :span="6">
                  <div
                    class="upload-btn lv3Text"
                    @click="openChooser"
                    v-if="!(images[1]&&images[2]&&images[3])"
                  >
                    <i class="fas fa-plus"></i>
                  </div>
                </el-col>
              </el-row>
            </el-form-item>
            <el-form-item label="反馈表：">
              <el-button style="margin-bottom:20px" @click="temp()">点击下载产品反馈表</el-button>
              <el-upload
                class="upload-demo"
                action
                :on-change="handleChange"
                :auto-upload="false"
                :limit="1"
              >
                <el-button>点击上传产品反馈表</el-button>
                <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
              </el-upload>
            </el-form-item>
            <div hidden>
              <input type="file" @change="chooerImage($event,1)" ref="chooser1" />
              <input type="file" @change="chooerImage($event,2)" ref="chooser2" />
              <input type="file" @change="chooerImage($event,3)" ref="chooser3" />
            </div>
          </el-form>
        </div>
        <div class="lv3Text" style="margin:20px 0">填写信息</div>
        <div class="form">
          <el-form label-position="right" label-width="100px" style="width:80%;margin:0 auto;">
            <el-form-item label="联系人：" style="width:300px;">
              <el-input v-model="form.link_name"></el-input>
            </el-form-item>
            <el-form-item label="联系电话：" style="width:300px;">
              <el-input v-model="form.link_mobile"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div align="center" style="margin-top:30px;margin-bottom:20px">
          <el-button type="primary" style="width:150px;" @click="submit">确认提交</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      //
      serve: this.$store.state.serve,
      mobile: this.$cookies.get("user"),
      token: this.$cookies.get("token"),
      form: {
        number: 1
      },
      options: ["申请退货", "申请退款"],
      images: [],
      files: [],
      data: "",
      result: false,
      file: {}
    };
  },
  created() {
    //
    this.data = JSON.parse(this.$route.query.data);
    this.$store.state.user_location = "售后服务";
    this.$store.state.leftMenuIndex = 15;
  },
  methods: {
    //
    handleChange(file) {
      this.file = file.raw;
    },
    temp() {
      window.location.href =
        this.serve +
        "/personal/download_return_model?token=" +
        this.token +
        "&" +
        "mobile=" +
        this.mobile;
    },
    submit() {
      var form = new FormData();
      form.append("mobile", this.mobile);
      form.append("token", this.token);
      form.append("item_id", this.data.item_id);
      form.append("number", this.data.number);
      form.append("type", this.form.type);
      form.append("cause", this.form.cause);
      form.append("link_name", this.form.link_name);
      form.append("link_mobile", this.form.link_mobile);
      form.append("image1", this.files[1]);
      form.append("image2", this.files[2]);
      form.append("image3", this.files[3]);
      form.append("file", this.file);
      let config = {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      };
      // for (var pair of form.entries()) {
      // }
      var that = this;
      this.axios
        .post(this.serve + "/personal/return_product", form, config)
        .then(function(res) {
          if (res.data.status == "success") {
            that.result = true;
          } else {
            that.$message.error(res.data.msg);
          }
        });
    },
    chooerImage(e, index) {
      var reader = new FileReader();
      var that = this;
      var file = e.target.files[0];
      reader.readAsDataURL(e.target.files[0]);
      reader.onload = function(err) {
        var base64Code = this.result;
        that.$set(that.images, index, base64Code);
        that.$set(that.files, index, e.target.files[0]);
      };
      this.$set(this.form, "image" + index, event.target.files[0]);
    },
    openChooser() {
      for (var i = 1; i < 4; i++) {
        if (_.isEmpty(this.images[i])) {
          this.$refs["chooser" + i].click();
          return;
        }
      }
    },
    initData() {
      var json = {
        mobile: this.mobile,
        token: this.token,
        status: 5,
        page: this.page
      };
      this.axios
        .get(this.serve + "/personal/order_list", {
          params: json
        })
        .then(res => {});
    }
  }
};
</script>
<style lang="scss">
#afterForm {
  .result {
    font-size: 30px;
    text-align: center;
    padding: 30px 0;
  }
  .box {
    background-color: #fff;
    border: 1px solid #ddd;
    padding: 30px 20px;
  }
  .upload-btn {
    border: 2px dotted #ddd;
    display: inline-block;
    height: 100px;
    width: 100px;
    text-align: center;
    line-height: 100px;
    border-radius: 15px;
    cursor: pointer;
  }
  .cover {
    height: 100px;
    width: 100px;
  }
  .cover2 {
    width: 50px;
    height: 50px;
  }
  .upload-btn:hover {
    background-color: #f2f6fc;
  }
  .form {
    border: 1px solid #ddd;
    padding: 20px 0;
  }
}
</style>